// extracted by mini-css-extract-plugin
module.exports = {"buttonSelect":"button_select_buttonSelect__w2xIA","or":"button_select_or__6REyQ","wrapper":"button_select_wrapper__17Eg2","line":"button_select_line__1obqB"};